import type { PropsWithChildren, ReactElement } from "react";

import type {
    CustomBasicModalProps,
} from "app/pages/sales-intelligence/common-components/modals/CustomBasicModal/CustomBasicModal";
import CustomBasicModal from "app/pages/sales-intelligence/common-components/modals/CustomBasicModal/CustomBasicModal";

import { ONBOARDING_MODAL_STYLES } from "./styles";

const OnboardingModal = ({
    isOpen,
    onClose,
    closeIconStyles,
    children,
}: PropsWithChildren<Pick<CustomBasicModalProps, "isOpen" | "onClose" | "closeIconStyles">>): ReactElement => {
    return (
        <CustomBasicModal
            isOpen={isOpen}
            onClose={onClose}
            customStyles={ONBOARDING_MODAL_STYLES}
            shouldCloseOnOverlayClick={false}
            withCloseIcon={!!onClose}
            closeIconStyles={closeIconStyles}
        >
            {children}
        </CustomBasicModal>
    );
};

export default OnboardingModal;
